'use client';

import { useEffect, useState } from 'react';
import { getIsLogin } from 'lowcode/utils/getIsLogin';
import CompPage from './CompPage';
import WinItemA from './WinItemA';
import WinItemB from './WinItemB';
import CompWin from './CompWin';
import MoreBtn from './MoreBtn';
import { selectByUserId } from './apis';
import getLocal from '@/app/utils/getLocal';

export default function Content({ data }: any) {
    const { locale } = getLocal();
    const [activeType, setActiveType] = useState('Discount');
    const [openWin, setOpenWin] = useState(false);
    const [openItemFlagA, setOpenItemFlagA] = useState(false); // tab A
    const [openItemFlagB, setOpenItemFlagB] = useState(false); // tab B
    const [isExchangeA, setIsExchangeA] = useState(false); // tab A-是否是兑换
    const [isExchangeB, setIsExchangeB] = useState(false); // tab B-表单
    const [openItem, setOpenItem] = useState<any>({});
    const [creditsData, setCreditsData] = useState({}); //登录用户积分
    const [isLoginA, setIsLoginA] = useState({}); //是否登录

    // tab点击切换
    const tabCallback = (item: any) => {
        setActiveType(item.value);
    };
    // win
    const winCallback = (type: string) => {
        if (type === 'open') {
            setOpenWin(true);
        } else if (type === 'close') {
            setOpenWin(false);
        }
    };
    // isExchangeA:是否点击按钮 tabType:点击第几个tab
    const winItemCallback = (type: string, data: any, isBottomButton = false, tabType: string) => {
        if (type === 'close') {
            setOpenItemFlagA(false);
            setOpenItemFlagB(false);
            setOpenItem({});
        } else {
            if (tabType === 'tabA' && isBottomButton) {
                // 执行兑换
                setOpenItemFlagA(true);
                setIsExchangeA(true);
            } else if (tabType === 'tabA' && !isBottomButton) {
                setOpenItemFlagA(true);
                setIsExchangeA(false);
            } else if (tabType === 'tabB' && isBottomButton) {
                setOpenItemFlagB(true);
                setIsExchangeB(true);
            } else if (tabType === 'tabB' && !isBottomButton) {
                setOpenItemFlagB(true);
                setIsExchangeB(false);
            }
            setOpenItem(data || {});
        }
    };

    useEffect(() => {
        const isLoginA2 = getIsLogin();
        const initFn = async () => {
            const res = await selectByUserId(locale);
            if (res.code === '0') {
                setCreditsData(res.data);
                console.log('creditsData', creditsData);
            }
        };
        if (isLoginA2) {
            initFn();
        }
        setIsLoginA(isLoginA2);
    }, []);
    return (
        <div className={`eco-redeem-redeem-rewards-in ${isLoginA ? 'eco-redeem-redeem-login-y' : 'eco-redeem-redeem-login-n'}`}>
            <CompPage
                data={data}
                creditsData={creditsData}
                activeType={activeType}
                callback={tabCallback}
                winCallback={winCallback}
                itemCallback={winItemCallback}
            />
            {openWin && (
                <CompWin
                    data={data}
                    creditsData={creditsData}
                    activeType={activeType}
                    callback={tabCallback}
                    winCallback={winCallback}
                    itemCallback={winItemCallback}
                />
            )}
            {openItemFlagA && (
                <WinItemA isExchange={isExchangeA} creditsData={creditsData} activeType={activeType} data={openItem} winItemCallback={winItemCallback} />
            )}
            {openItemFlagB && (
                <WinItemB isExchange={isExchangeB} creditsData={creditsData} activeType={activeType} data={openItem} winItemCallback={winItemCallback} />
            )}
            <div className="eco-redeem-rewards-footer">
                <MoreBtn winCallback={winCallback} />
            </div>
        </div>
    );
}
